export default {
  layout: {
    "rows": [
      {
        "fields": [ { "name": "folder.name" } ]
      },

      {
        "fields": [ { "name": "folder.description" } ]
      },

      {
        "fields": [ { "name": "folder.userGroups" } ]
      }
    ]
  }
}
